import { Table, Pagination, Spin, Empty } from '@bfe/moly';
import { useData, useColumns } from './hooks';
import { QuickjumpIcon, ArrowchevronRightIcon } from '@bfe/moly-icons';
import clx from 'classnames';
import { useFm } from '@web3/base-hooks';
import { formatNumber } from '@web3/base-utils';

import ArkhamLogo from '@/assets/svg/home/arkham_logo.svg';
import { CommonLoading } from '@/components/CommonLoading';

import styles from './index.module.scss';

export const HackerAddress = () => {
  const { data, loading, pageNo, totalListNum, pageSize, onChangePageNo } =
    useData();
  const { cols } = useColumns();
  const fm = useFm();

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.addressCount}>
          <span>{fm('addressCount')}</span>
          <span className={styles.num}>{totalListNum || '--'}</span>
        </div>
        <div className={styles.divid} />
        <div
          className={styles.arkham}
          onClick={() => {
            window.open(
              'https://intel.arkm.com/explorer/entity/bybit-hacker',
              '_blank'
            );
          }}
        >
          <ArkhamLogo className={styles.arkhamLogo} />
          <span className={styles.name}>Arkham tracker</span>
          <QuickjumpIcon className={styles.quickJump} />
        </div>
      </div>
      <div className={styles.pc}>
        <CommonLoading loading={loading}>
          <Table
            columns={cols}
            data={data}
            className={styles.table}
            height="540px"
            emptyText={fm('noRecords')}
          />
        </CommonLoading>
      </div>
      <div className={styles.mobile}>
        {loading && <CommonLoading loading={loading} />}
        {!loading && data.length === 0 && <Empty subTitle={fm('noRecords')} />}
        {!loading && data.length > 0 && (
          <>
            {data.map((item, index) => {
              return (
                <div key={index} className={styles.item}>
                  <div className={styles.lr}>
                    <div className={styles.cell}>
                      <div className={styles.label}>{fm('address')}</div>
                      <div className={styles.content}>
                        <span className="font-mono">
                          {item?.address
                            ? `${item?.address?.slice(0, 10)}...${item?.address?.slice(-4)}`
                            : '--'}
                        </span>
                      </div>
                    </div>
                    <div className={clx(styles.cell, styles.itemEnd)}>
                      <div className={styles.label}>{fm('network')}</div>
                      <div className={styles.content}>
                        {item?.chain || '--'}
                      </div>
                    </div>
                  </div>
                  <div className={clx(styles.lr, styles.itemEnd)}>
                    <div className={styles.cell}>
                      <div className={styles.label}>
                        {fm('walletBalanceUsd')}
                      </div>
                      <div className={styles.content}>
                        {item?.holdingValue
                          ? `$${formatNumber(item?.holdingValue, {
                              kmb: false,
                              noTrailZero: true,
                            })}`
                          : '--'}
                      </div>
                    </div>
                    <div className={clx(styles.cell, styles.itemEnd)}>
                      <div
                        className={clx(styles.content, styles.action)}
                        onClick={() => {
                          if (!item?.address) return;
                          window.open(
                            `https://intel.arkm.com/explorer/address/${item?.address}`,
                            '_blank'
                          );
                        }}
                      >
                        <span>{fm('viewMore')}</span>
                        <ArrowchevronRightIcon className={styles.arrow} />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
      {totalListNum > pageSize && (
        <Pagination
          current={pageNo}
          total={totalListNum}
          pageSize={pageSize}
          align="center"
          onChange={onChangePageNo}
          rootClassName={styles.pagination}
        />
      )}
    </div>
  );
};
